/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Vehicle_Filter_PlaceholderInputs */

const fr_network_vehicle_filter_placeholder = /** @type {(inputs: Network_Vehicle_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`numéro ou désignation`)
};

const en_network_vehicle_filter_placeholder = /** @type {(inputs: Network_Vehicle_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`number or designation`)
};

/**
* | output |
* | --- |
* | "number or designation" |
*
* @param {Network_Vehicle_Filter_PlaceholderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicle_filter_placeholder = /** @type {((inputs?: Network_Vehicle_Filter_PlaceholderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicle_Filter_PlaceholderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicle_filter_placeholder(inputs)
	return en_network_vehicle_filter_placeholder(inputs)
});